import React from 'react';
import Input from '../../../components/ui/Input';

interface CurrencyInputProps {
    label: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
}

export const CurrencyInput: React.FC<CurrencyInputProps> = ({
    label,
    name,
    value,
    onChange,
    placeholder = '0,00'
}) => {
    return (
        <Input
            label={label}
            name={name}
            type="text"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            inputSize="md"
            icon={<span className="text-muted text-sm font-medium">R$</span>}
        />
    );
};

export default CurrencyInput;
